import { Switch } from 'react-router-dom'
import DefaultRevenueList from './DefaultRevenueList'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_TROUBLESHOOT } from 'app-support/permissions/Permissions'
import { defaultRevenueRoute, troubleshootRoute } from 'routes/routeNames'

const enhance = withRegionSwitchHandler(troubleshootRoute)

const DefaultRevenueContainer = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_TROUBLESHOOT} exact path={defaultRevenueRoute} component={DefaultRevenueList} />
  </Switch>
)

export default enhance(DefaultRevenueContainer)
